import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { CatalogueDefaultProps } from 'src/containers/catalogue-container/CataloguePropTypes';
import { CATALOGUE_ACTIONS } from '../actions/CatalogueActions';

const initialState = () => ({
    currentRecord: { ...CatalogueDefaultProps },
    currentRecordPopulated: { ...CatalogueDefaultProps },

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        // SEARCH
        case CATALOGUE_ACTIONS.CATALOGUE_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case CATALOGUE_ACTIONS.CATALOGUE_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case CATALOGUE_ACTIONS.CATALOGUE_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // UPSERT
        case CATALOGUE_ACTIONS.CATALOGUE_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case CATALOGUE_ACTIONS.CATALOGUE_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case CATALOGUE_ACTIONS.CATALOGUE_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        case CATALOGUE_ACTIONS.CATALOGUE_POPULATED_RECORD_UPDATE: {
            return {
                ...state,
                currentRecordPopulated: action.data,
            };
        }

        // RESET
        case CATALOGUE_ACTIONS.CATALOGUE_RESET: {
            return {
                ...state,
                currentRecord: { ...CatalogueDefaultProps },
            };
        }
        default:
            return state;
    }
};
